import React, { Component } from 'react';

import { StyledPageContainer } from './styles/StyledPageContainer';

class PageContainer extends Component {
  render() {
     return (
      <StyledPageContainer>
        { this.props.children }
      </StyledPageContainer>
    );
  }
}

export default PageContainer;